const actions = {
  xLogin({ commit }, _userInfo) {
    if (_userInfo.type == 'manager') {
      sessionStorage.setItem('managerRouter', JSON.stringify(_userInfo.router))
      sessionStorage.setItem(
        'companyList',
        JSON.stringify(_userInfo.company_list)
      )
      commit('SET_COMPANY_LIST', _userInfo.company_list)
    }
    commit('SET_LOGIN_STATUS', true)
    commit('SET_LOGIN_TYPE', _userInfo.type)
    sessionStorage.setItem('loginType', _userInfo.type)
    sessionStorage.setItem('loginStatus', true)
    sessionStorage.setItem('companyId', _userInfo.company_id)
  },
  xLogout({ commit, state }) {
    if (state.loginType == 'manager') {
      sessionStorage.removeItem('managerRouter')
      sessionStorage.removeItem('companyList')
      commit('SET_COMPANY_LIST', [])
    }
    commit('SET_LOGIN_STATUS', false)
    commit('SET_Manager_ROUTER', [])
    sessionStorage.removeItem('loginStatus', false)
  },
  xSetCompanyName({ commit }, _name) {
    commit('SET_COMPANY_NAME', _name)
    sessionStorage.setItem('companyName', _name)
  },
}

export default actions
